import { useEffect, useState } from 'react';
import { Badge, Space, Tooltip } from 'antd';
import { listIcs2CustomsRequests } from 'store/declarations/eu/ics2/customs-requests/client';
import { isReferralEditable } from 'store/declarations/eu/ics2/customs-requests/utils';

type Props = {
    declarationId?: string;
    refreshKey?: string;
};

/**
 * "Customs Requests" plus the number of referrals still awaiting an answer.
 *
 * The count spans every IE3Q02/IE3Q03 on the declaration, which is the point of the tab: several
 * messages can hold open referrals at the same time.
 */
const CustomsRequestsTabLabel = ({ declarationId, refreshKey }: Props) => {
    const [count, setCount] = useState<number>();

    useEffect(() => {
        if (!declarationId) return;
        let cancelled = false;
        listIcs2CustomsRequests(declarationId)
            .then((requests) => {
                if (cancelled) return;
                setCount(
                    requests
                        .flatMap((request) => request.referrals)
                        .filter((referral) => isReferralEditable(referral.status)).length
                );
            })
            // A failed count must not break the tab bar; the tab itself reports the error.
            .catch(() => !cancelled && setCount(undefined));
        return () => {
            cancelled = true;
        };
    }, [declarationId, refreshKey]);

    return (
        <Space size={6}>
            Customs Requests
            {Boolean(count) && (
                <Tooltip title="Referrals still to answer">
                    <Badge count={count} />
                </Tooltip>
            )}
        </Space>
    );
};

export default CustomsRequestsTabLabel;
